import axios from 'axios';
import config from '../config/app.js';
import store from '../src/store/store';

// set api config
let api = axios.create({
	'baseURL': config.apiUrl
});

// get refresh token if necessary
api.interceptors.response.use(undefined, function(err) {
	if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
		setTimeout()
	}
})

function listener() {
	let state = store.getState();
	let token = state.User.User.token; 
	api.defaults.headers.common['x-access-token'] = token;
}

store.subscribe(listener);

export default api;


//////////////////
// WEBPACK FOOTER
// ./config/api.js
// module id = 61
// module chunks = 0